import { render } from "./ContentSelectCollection.vue?vue&type=template&id=52dc2bea"
import script from "./ContentSelectCollection.vue?vue&type=script&lang=js"
export * from "./ContentSelectCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__